import { atom } from 'recoil';
import type {
  AccountStyle_Input,
  Image__Input,
  WidgetSettingsStyles__Input,
} from '~/graphql/types';

export type BrandSettingsState = {
  unsubscribeLinkText: string | null;
  logo: Image__Input | null;
  teamImage: Image__Input | null;
  backgroundImage: Image__Input | null;
  colors: WidgetSettingsStyles__Input | null;
  url: string | null;
  style: AccountStyle_Input | null;
};

export const defaultColors = {
  primary: {
    color: '#fff',
    background: '#fff',
  },
  secondary: {
    color: '#fff',
    background: '#fff',
  },
} as const;

export const defaultChangesState: BrandSettingsState = {
  unsubscribeLinkText: null,
  logo: null,
  teamImage: null,
  backgroundImage: null,
  colors: defaultColors,
  url: null,
  style: {
    fontFamily: null,
  },
};

export const brandSettingsCurrent = atom<BrandSettingsState>({
  key: 'brandSettingsCurrent',
  default: defaultChangesState,
});

export const brandSettingsInitial = atom<BrandSettingsState>({
  key: 'brandSettingsInitial',
  default: defaultChangesState,
});
